import axiosClient from './axiosClient';
import { IBaseResponse } from '~/utils/interface/base';
import { IConfigValues, IUpdateConfigItem } from '~/utils/interface/config';

const urlApiConfig = 'configs';

const configApi = {
  getConfig() {
    return axiosClient.get<IBaseResponse<{ config: IConfigValues }>>(urlApiConfig);
  },
  updateConfigs(configs: IUpdateConfigItem[]) {
    return axiosClient.put<IBaseResponse<unknown>>(`${urlApiConfig}/multiple`, { configs });
  },
};

export default configApi;
